import fr from 'facet-rest';
import PasswordInput from 'Components/ComponentLibrary/Components/Inputs/Password';
import BaseOverride from './BaseOverride';

const AccountSetupOverride = fr.metaOverride({ base: BaseOverride })
  .override({ hint: 'sensitive' }, {
    _component: () => PasswordInput,
  });

export default AccountSetupOverride;
